/**
 * File: src/main.js
 * Mô tả: Điểm khởi chạy chính (Entry Point) của ứng dụng, nạp hệ thống CSS và khởi tạo App Router.
 * Liên quan: index.html, src/app-router.js, src/components/header.js, src/components/footer.js
 */

// Nạp hệ thống CSS Design Tokens & Components
import './styles/tokens.css';
import './styles/base.css';
import './styles/layout.css';
import './styles/components.css';
import './styles/responsive.css';

// Nạp UI Utilities & App Router
import { renderHeader } from './components/header.js';
import { renderFooter } from './components/footer.js';
import { renderLightbox } from './components/lightbox.js';
import { initAnalytics } from './services/analytics-service.js';
import { initAppRouter } from './app-router.js';

document.addEventListener('DOMContentLoaded', () => {
  const appContainer = document.querySelector('#app');
  if (!appContainer) {
    console.error('Không tìm thấy element #app để khởi tạo ứng dụng SNT Games.');
    return;
  }

  // Render Header cố định
  appContainer.appendChild(renderHeader());

  // Thẻ <main> chứa nội dung thay đổi theo Route
  const mainElement = document.createElement('main');
  mainElement.id = 'router-view';
  appContainer.appendChild(mainElement);

  // Render Footer cố định & Global Modals
  appContainer.appendChild(renderFooter());
  appContainer.appendChild(renderLightbox());

  initAnalytics();
  // Khởi tạo router chuyển đổi giữa các trang (/ , /games/ant-clash , /admin)
  initAppRouter(mainElement);
});
